module.exports = __webpack_public_path__ + "img/5-424-424.8717e0b8.png";